{
  "nav": {
    "overview": "Overview",
    "campaigns": "Campaigns",
    "billing": "Subscription",
    "notifications": "Notifications",
    "users": "Users",
    "adminBilling": "Billing",
    "broadcasts": "Broadcasts",
    "globalConfig": "Filtering",
    "account": "Account",
    "actions": "Actions"
  },
  "actions": {
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "confirm": "Confirm",
    "copy": "Copy",
    "create": "Create",
    "delete": "Delete",
    "discard": "Discard",
    "edit": "Edit",
    "language": "Change language",
    "reload": "Reload",
    "retry": "Retry",
    "save": "Save",
    "search": "Search",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "themeDark": "Dark theme",
    "themeLight": "Light theme"
  },
  "locale": {
    "en": "English",
    "ru": "Русский"
  },
  "states": {
    "loading": "Loading…",
    "empty": "Nothing here yet",
    "reconnecting": "Reconnecting…",
    "newRows_one": "{{count}} new row",
    "newRows_other": "{{count}} new rows",
    "unknown": "Unknown"
  },
  "errors": {
    "title": "Could not load this",
    "offlineTitle": "No connection",
    "forbiddenTitle": "No access",
    "chunkTitle": "A new version was deployed",
    "chunkMessage": "Reload the page to continue.",
    "renderTitle": "Something broke on this screen",
    "OFFLINE": "The network is unavailable. Check your connection and try again.",
    "TIMEOUT": "The server took too long to answer.",
    "INVALID_RESPONSE": "The server returned data this screen does not understand.",
    "SERVER_ERROR": "The server failed to process this request.",
    "UNKNOWN": "Something went wrong.",
    "BAD_REQUEST": "The request was rejected.",
    "PAYMENT_REQUIRED": "An active subscription is required.",
    "UNAUTHORIZED": "The session has expired. Sign in again.",
    "FORBIDDEN": "You do not have access to this action.",
    "NOT_FOUND": "This record no longer exists.",
    "CONFLICT": "The data changed. Reload the page.",
    "VALIDATION_ERROR": "Check the fields you filled in.",
    "TOO_MANY_REQUESTS": "Too many requests. Wait a moment.",
    "INTERNAL_SERVER_ERROR": "The server failed to process this request.",
    "SERVICE_UNAVAILABLE": "The service is temporarily unavailable.",
    "GOAUTH_ALREADY_EXISTS": "That username or email is already taken.",
    "GOAUTH_LAST_ADMIN": "This is the last active administrator.",
    "GOAUTH_SELF_DEMOTE": "You cannot remove your own admin rights.",
    "GOAUTH_REAUTH_REQUIRED": "Password confirmation is required.",
    "GOAUTH_PASSWORD_TOO_SHORT": "The password is too short.",
    "GOAUTH_INVALID_IDENTIFIER": "Invalid username or email.",
    "GOAUTH_NO_IDENTIFIER": "A username or email is required.",
    "GOAUTH_INVALID_CREDENTIALS": "Wrong password.",
    "GOAUTH_ACCOUNT_BLOCKED": "This account is blocked.",
    "GOAUTH_ACCOUNT_DELETED": "This account is deleted."
  },
  "auth": {
    "signInTitle": "Sign in",
    "email": "Email",
    "password": "Password",
    "signInFailed": "Sign in failed"
  },
  "validation": {
    "required": "This field is required",
    "email": "Enter a valid email",
    "min": "At least {{count}} characters",
    "max": "At most {{count}} characters"
  },
  "ui": {
    "allSections": "All sections",
    "breadcrumb": "Breadcrumb",
    "clear": "Clear",
    "copied": "Copied",
    "loading": "Loading",
    "more": "More",
    "nextPage": "Next page",
    "noMatchDescription": "Change the query or clear the filters.",
    "notSelected": "Not selected",
    "nothingFound": "Nothing found",
    "nothingSelected": "Nothing selected",
    "opened": "Open",
    "pages": "Pages",
    "prevPage": "Previous page",
    "rangeOf": "{{from}}–{{to}} of {{total}}",
    "remove": "Remove",
    "resetFilters": "Reset filters",
    "rowActions": "Actions",
    "rowsPerPage": "Rows per page",
    "sections": "Sections",
    "selectAll": "Select all",
    "selectRow": "Select row",
    "selectedCount": "Selected: {{count}}",
    "selectedOf": "{{count}} of {{total}}",
    "tableScroll": "Table, scrolls horizontally",
    "thisSession": "Current session"
  },
  "source": {
    "google_search": "Google Search",
    "google_ads": "Google Ads",
    "meta_ads": "Meta Ads",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "reddit": "Reddit",
    "reddit_ads": "Reddit Ads",
    "x": "X",
    "x_ads": "X Ads",
    "bing_search": "Bing Search",
    "bing_ads": "Bing Ads",
    "yandex_search": "Yandex Search",
    "yandex_ads": "Yandex Direct",
    "telegram": "Telegram",
    "whatsapp": "WhatsApp",
    "direct": "Direct",
    "organic": "Organic",
    "unknown": "Unknown"
  },
  "device": {
    "desktop": "Desktop",
    "mobile": "Mobile",
    "tablet": "Tablet"
  },
  "os": {
    "windows": "Windows",
    "macos": "macOS",
    "linux": "Linux",
    "android": "Android",
    "ios": "iOS"
  },
  "unsaved": {
    "title": "Unsaved changes",
    "description": "Leaving now discards the edits in this form.",
    "stay": "Stay",
    "leave": "Leave without saving"
  },
  "form": {
    "unsaved": "You have unsaved changes"
  }
}
